import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Organization {
  _id: string;
  organizationName: string;
  defaultUser: {
    firstName: string;
    lastName: string;
    email: string;
    role: string;
  };
  createdAt: string;
  updatedAt: string;
}

export type AddOrganizationPayload = {
  organizationName: string;
  timezone?: string;
  defaultUser: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    role: string;
  };
};

export type AddOrganizationResponse = {
  success: boolean;
  message: string;
  data: Organization;
};

const addOrganization = async (
  payload: AddOrganizationPayload
): Promise<AddOrganizationResponse> => {
  const { data } = await customAxios.post<AddOrganizationResponse>(
    "/super-admin/organizations",
    payload
  );
  return data;
};

export const useAddOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation<
    AddOrganizationResponse,
    AxiosError,
    AddOrganizationPayload
  >({
    mutationFn: addOrganization,
    onSuccess: async (data) => {
      showNotification({
        title: "Success",
        message: data.message,
        color: "green",
      });

      await queryClient.invalidateQueries(["organizations"]);
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to add organization",
        color: "red",
      }),
  });
};
